// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__16Qyg","choiceBoxes":"toolbarselects_choiceBoxes__XW4JO","simpleField":"toolbarselects_simpleField__1F2Yl"};